import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { BrandLogo } from '@/components/branding/BrandLogo';

/** Redirige a la ruta correcta según el estado del usuario (computeLandingRoute). */
export function LandingRedirect() {
  const { firebaseUser, appUser, loading, computeLandingRoute } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-6 bg-muted/30">
        <BrandLogo variant="full" size={108} alt="PsyTalent" />
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (!firebaseUser || !appUser) {
    return <Navigate to="/login" replace />;
  }

  const to = computeLandingRoute(appUser);
  return <Navigate to={to} replace />;
}
